import { render } from "./comingsoon_simple.vue?vue&type=template&id=b28d35d6"
import script from "./comingsoon_simple.vue?vue&type=script&lang=js"
export * from "./comingsoon_simple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__